export default __webpack_public_path__ + "static/media/NCBI.b2e87a41.png";